import { HcsDelegateRoleRefIds, useGetIdsReferencesHcsroles } from '@toktokdoctech/tokapi-client'
import useUserPermissions from './useUserPermissions'

const useFetchUserRoles = () => {
    const { data, isLoading, error } = useGetIdsReferencesHcsroles()
    const { hasUserPermission } = useUserPermissions()

    const hcsDelegateRoles = data
        ?.reduce<HcsDelegateRoleRefIds[]>((prev, curr) => {
            if (curr) {
                if (hasUserPermission('SUPER ADMIN')) {
                    prev.push(curr)
                } else if (curr.code && curr.code > 0) {
                    prev.push(curr)
                }
            }

            return prev
        }, [])
        .sort((a, b) => (Number(a.code) < Number(b.code) ? 1 : -1))

    const defaultHcsDelegateRole = hcsDelegateRoles?.reduce<HcsDelegateRoleRefIds | undefined>((prev, curr) => {
        const currCode = curr?.code ?? 0
        const prevCode = prev?.code ?? 0

        if (currCode > prevCode) {
            return curr
        }

        return prev
    }, undefined)

    return {
        isLoading,
        error: error || !hcsDelegateRoles || hcsDelegateRoles.length === 0 || !defaultHcsDelegateRole,
        hcsDelegateRoles,
        defaultHcsDelegateRole,
    }
}

export default useFetchUserRoles
